

























































































import { Component, Vue, Mixins } from 'vue-property-decorator';
import TopMenu from '@/components/TopMenu.vue';
import UserMixin from '@/mixins/UserMixin';
import PromiseLoaderMixin from '@/mixins/PromiseLoaderMixin';
import { IDevicesState } from '@/store/types';
import { State, Getter, Mutation } from 'vuex-class';
import { DeviceInfo } from '../../common/apis/DeviceApi';
import { mapGetters } from 'vuex';
import SoftwareUpdateAvailableIcon from '@/components/SoftwareUpdateAvailableIcon.vue';
import ApiProvider from '@/common/apis/ApiProvider';

@Component({
    components: {
        TopMenu,
        SoftwareUpdateAvailableIcon,
    },
})
export default class Devices extends Mixins(UserMixin, PromiseLoaderMixin) {

    @State('devices')
    public deviceState!: IDevicesState;

    @Getter('devices/sorted')
    public devicesSorted!: DeviceInfo[];

    @Getter('devices/newDevices')
    public newDevices: DeviceInfo[];

    public isPairing: boolean = false;


    public get loading(): boolean {
        return this.deviceState.loading;
    }

    private intervalRef: number;

    public hasConnection(device: DeviceInfo, connectionType: string): boolean {
        if (device && device.connections && device.connections.some((c) => c.connectionType === connectionType)) {
            return true;
        }
        return false;
    }

    public isConnectionOnline(device: DeviceInfo, connectionType: string | null = null): boolean {
        if (device && device.connections && device.connections.some(
            (c) => (((c.connectionType || '')  === connectionType || connectionType === null) && c.online) || false)
        ) {
            return true;
        }
        return false;
    }

    public async pair(device: DeviceInfo) {
         if (device
            && device.connections
            && device.connections.some((c) => c.online || false)
            && !this.isDemo) {
            this.isPairing = true;
            try {
                const api = ApiProvider.getDeviceApi();
                const response = await api.pairDevice(device.number);
                this.$router.push('/buttons/' + device.number);
                try {
                    // We need to restart the device to ensure that the bluetooth etc. is updated
                    await api.restartDevice(device.number);
                } finally { /* do nothing */ }
            } catch (e) {
                this.isPairing = false;
            }
            this.isPairing = false;
        }
    }

    public deviceClick(device: DeviceInfo) {
        if (device
            && device.connections
            && device.connections.some((c) => c.online || false)) {
            this.$router.push('/buttons/' + device.number);
        }
    }



    public mounted() {
        this.verifyLoginStatus(true);
        this.loadPromises([
            {name: 'devices/load', promise: () => this.$store.dispatch('devices/load', {reload: true})},
        ], {
            reloadDataInterval: 5000,
        });
        if (this.userState.lastVisitedUrl) {
            this.$router.push(this.userState.lastVisitedUrl);
        }

        // ;
        // this.intervalRef = setInterval(() => {
        //     this.$store.dispatch('devices/load', {reload: true});
        // }, 5000);
    }
    // public beforeDestroy() {
    //     clearInterval(this.intervalRef);
    // }

    public async logOff() {
        const api = ApiProvider.getEventApi();
        api.stop();
        await this.$store.dispatch('logOff');
        this.$router.replace('/login');
    }
}

